import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'lgv-ssn-input',
    templateUrl: './ssn-input.component.html',
    styleUrls: ['./ssn-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SsnInputComponent implements OnInit {
    @Input() ssnInputControl: FormControl;

    ngOnInit() {
        this.setInitialValue();
    }

    _ssn = '';
    ssnType$ = new BehaviorSubject('password');
    showSSN = false;

    setInitialValue() {
        let temp: string = this.ssnInputControl?.value?.toString();
        if (temp && temp.startsWith('*****')) {
            temp = temp.replace('*****', '***-**-');
        }
        this._ssn = temp;
    }

    onToggleShowSSN() {
        this.showSSN = !this.showSSN;
        this.ssnType$.next(this.showSSN ? 'text' : 'password');
    }

    onSSNChange(event: any) {
        this._ssn = this.getSSNValidFormat(this._ssn);
    }

    private getSSNValidFormat(ssn: string): string | null {
        if (ssn === null || ssn === undefined) { return null; }

        const pattern = /\d{3}-\d{2}-\d{4}/g;
        let formattedSSN = ssn as any;
        const result = pattern.test(formattedSSN);
        if (!result) {
            formattedSSN = formattedSSN.match(/\d*/g).join('')
                .match(/(\d{0,3})(\d{0,2})(\d{0,4})/).slice(1).join('-')
                .replace(/-*$/g, '');
        }

        return formattedSSN;
    }


}
